import styled from 'styled-components';

const Wrapper = styled.div`
  line-height: 1.618;
  color: ${({ theme }) => theme.colors.white};
  display: inline-flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brand_tint_blue};
  font-size: 0.75rem;
  border-radius: 0.25em;
  padding: 0 0.75em;
  user-select: none;
`;

function Tag({children}) {
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
}

export default Tag;